import { IMetricsLoggerClient, Unit } from '@amzn/exs-client-logging/v2';
import { StandardMetricTypes } from '@amzn/exs-gem-metric-types';

export const emitLatency = (
    metricLogger: IMetricsLoggerClient,
    metricType: StandardMetricTypes,
    metricValue: number
) => {
    metricLogger.putMetric(metricType, metricValue, Unit.Milliseconds).flush();
};

export const emitCount = (
    metricLogger: IMetricsLoggerClient,
    metricType: StandardMetricTypes,
    metricValue: number
) => {
    metricLogger.putMetric(metricType, metricValue, Unit.Count).flush();
};
